import { animate, AUTO_STYLE, state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { DEFAULT_DURATION } from '../../expansion-panel/collapse/collapse.component';

@Component({
  standalone: true,
  selector: 'filter-collapse',
  templateUrl: './filter-collapse.component.html',
  styleUrls: ['./filter-collapse.component.scss'],
  animations: [
    trigger('collapse', [
      state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
      state('true', style({ height: '0', visibility: 'hidden' })),
      transition('false => true', animate(DEFAULT_DURATION + 'ms ease-in')),
      transition('true => false', animate(DEFAULT_DURATION + 'ms ease-out'))
    ])
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule]
})
export class FilterCollapseComponent {

  title = input<string>("");
  collapsed = input<boolean>(true);

  // Private signal for internal state (starts with input value)
  private _collapsed = signal<boolean>(this.collapsed());

  // Getter for template access
  get collapsedValue() {
    return this._collapsed();
  }

  toggle() {
    const currentValue = this._collapsed();
    this._collapsed.set(!currentValue);
  }

  expand() {
    this._collapsed.set(false);
  }

  collapse() {
    this._collapsed.set(true);
  }

}

